import styled from 'styled-components';

import SettingsModal from 'components/Settings/SettingsModal';

const CmiDigestModalWrapper = styled(SettingsModal)`
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: 710px;
  }

  .ant-modal-header {
    flex-shrink: 0;
    padding-bottom: 0 !important;
  }

  .settings-modal-title {
    height: 27px;
  }

  .ant-modal-body {
    padding: 0 !important;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    > div {
      flex: 1 1 auto;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  }

  .ant-modal-footer {
    flex-shrink: 0;
  }
`;

export default CmiDigestModalWrapper;
